import { render, staticRenderFns } from "./modalDeleteAccountStatement.vue?vue&type=template&id=54b0c236"
import script from "./modalDeleteAccountStatement.vue?vue&type=script&lang=js"
export * from "./modalDeleteAccountStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports